import type { Routes } from '@angular/router';
import { OnyxFormMode } from '@onyx/angular';
import type { FormResolverData } from '../../common/interfaces/common/form-resolver-data';
import { importGuard } from '../common/guards/import.guard';
import { FLEET_IMPORT_COLUMNS } from './common/constants/fleet-import-columns';
import { addFleetGuard } from './common/guards/add-fleet.guard';
import type { FleetForm } from './common/helpers/fleet-form.helper';
import { addFleetResolver } from './common/resolvers/add-fleet.resolver';
import { editFleetResolver } from './common/resolvers/edit-fleet.resolver';
import { fleetCardResolver } from './common/resolvers/fleet-card.resolver';
import { importFleetResolver } from './common/resolvers/import-fleet.resolver';

export type FleetFormResolverData = FormResolverData<FleetForm>;

export const FLEET_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./fleet-list/fleet-list.component').then(
        (m) => m.FleetListComponent,
      ),
  },
  {
    path: 'add',
    loadComponent: () =>
      import('./fleet-form/fleet-form.component').then(
        (m) => m.FleetFormComponent,
      ),
    canActivate: [addFleetGuard],
    data: { mode: OnyxFormMode.ADD },
    resolve: { data: addFleetResolver },
  },
  {
    path: 'import',
    loadComponent: () =>
      import('../common/components/import/import-result/import-result.component').then(
        (m) => m.ImportResultComponent,
      ),
    canActivate: [importGuard],
    data: { columns: FLEET_IMPORT_COLUMNS },
    resolve: { import: importFleetResolver },
  },
  {
    path: ':uuid/edit',
    loadComponent: () =>
      import('./fleet-form/fleet-form.component').then(
        (m) => m.FleetFormComponent,
      ),
    data: { mode: OnyxFormMode.EDIT },
    resolve: { data: editFleetResolver },
  },
  {
    path: ':uuid',
    children: [],
    resolve: { _: fleetCardResolver },
  },
] as const;
